<template>
  <div>
    <!-- 顶部渐变条与证书验证入口 -->
    <div class="top-gradient-bar" v-if="!fixed">
      <div class="top-gradient-inner">
        <div class="language-switcher">
          <div class="lang-btn" :class="currentLang === 'ZH' ? 'active' : ''" @click="switchLanguage('ZH')">中文</div>
          <div class="lang-btn" :class="currentLang === 'EN' ? 'active' : ''" @click="switchLanguage('EN')">EN</div>
        </div>
        <div class="certificate-link" @click="goToQuery">CERTIFICATE INQUIRY</div>
      </div>
    </div>
    <div class="topBox" :class="fixed ? 'topBoxFixed' : ''">
      <!-- 语言切换功能 -->
      <!-- <div class="language-switcher">
        <div class="lang-btn" :class="currentLang === 'ZH' ? 'active' : ''" @click="switchLanguage('ZH')">中文</div>
        <div class="lang-btn" :class="currentLang === 'EN' ? 'active' : ''" @click="switchLanguage('EN')">EN</div>
      </div> -->
      <!-- 顶部导航栏 -->
      <div class="top-con" :class="pageScroll ? 'top-con-bg' : ''">
        <div class="top-tabview">
          <!-- logo图片 -->
          <div class="top-leftlogo">
            <img
              src="../assets/images/homepage_head_logo.png"
              alt=""
              class="top-leftlogo-image"
              @click="goTohome()"
            >
          </div>
          <div class="right-menu-backview">
            <div class="right_tabbar_menuview" >
              <button
                :class="activeIndex === index ? 'chose_type' : 'normal_type'"
                v-for="(item, index) in tabBarList"
                :key="item.index"
                @mouseover="mouseover(item, index)"
                @mouseleave="mouseleave(index)"
                @click="handleToPage(item, index)"
              >
                {{ item.topTitle }}
              </button>
              <showAndCloseMenu>
                <div
                  class="tabbar_child_childmenu_backview"
                  @mouseleave="mouseleaveChildmenu()"
                  v-show="isActive"
                >
                  <div class="tabbar_child_childmenu">
                    <img
                      class="child-left-imgview"
                      :src="childLeftimg"
                      alt=""
                    />
                    <div class="child-left-descview">{{ childLeftDesc }}</div>
                    <div class="child-center-lineview"></div>
                    <div class="child-right-itemview">
                      <button
                        v-for="(
                          childItem, childSelectIndex
                        ) in seleTabChildList"
                        :class="
                          childMouseoverIndex === childSelectIndex
                            ? 'child-item-selectmenu'
                            : 'child-item-unselectmenu'
                        "
                        @mouseover="childMouseover(childSelectIndex)"
                        @click="childitemClicked(childSelectIndex, childItem)"
                        :key="childItem.childTitle"
                      >
                        {{ childItem.childTitle }}
                      </button>
                    </div>
                  </div>
                </div>
              </showAndCloseMenu>
            </div>
            <!-- 登录按钮区域 -->
            <div class="top-right-login-buttons" v-if="!userMenuVisible" :class="{ 'is-english': $i18n.locale === 'EN' }">
              <button
                class="login-btn login-btn-signin"
                @click="handleLoginClick"
              >
                <span class="login-text">SIGN IN</span>
              </button>
            </div>
            <LoginChoiceDialog
              :visible.sync="loginDialogVisible"
              @student="studentLoginClicked"
              @partner="partnerLoginClicked"
              @teacher="teacherLoginClicked"
            />
            <!-- 退出登录确认弹窗 -->
            <custom-confirm
              v-if="logoutConfirmVisible"
              :title="$t('h.logout')"
              :msg="$t('h.logoutConfirmMsg')"
              :confirm="$t('h.confirm')"
              :cancel="$t('h.cancel')"
              @confirm="handleLogoutConfirm"
              @cancel="handleLogoutCancel"
            ></custom-confirm>
            <!-- 移动端登录提示弹窗 -->
            <div class="mobile-login-tip-overlay" v-if="mobileLoginTipVisible" @click.self="closeMobileLoginTip">
              <div class="mobile-login-tip-dialog">
                <div class="tip-dialog-header">
                  <div class="tip-icon-wrapper">
                    <i class="el-icon-info"></i>
                  </div>
                  <div class="tip-title">{{ mobileLoginTipTitle }}</div>
                </div>
                <div class="tip-dialog-content">
                  <div class="tip-message">{{ mobileLoginTipMessage }}</div>
                </div>
                <div class="tip-dialog-footer">
                  <button class="tip-confirm-btn" @click="closeMobileLoginTip">
                    {{ mobileLoginTipConfirmText }}
                  </button>
                </div>
              </div>
            </div>
            <div class="top-right-user" v-if="userMenuVisible">
              <el-dropdown
                trigger="click"
                @visible-change="visibleChange"
                @command="userMenuCommand"
              >
                <div class="top-right-headView">
                  <img
                    src="../assets/images/top-userhead-place.png"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="userInfo"
                    icon="../assets/images/userinfo.png"
                    >{{ loginType === '1' ? $t('h.studentHome') : $t('h.userCenter')}}</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="loginOut"
                    icon="../assets/images/loginout.png"
                    divided
                    >{{ $t('h.logout') }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="top-bg-con" v-if="fixed">
        <!-- {{ title }} -->
      </div>
    </div>
  </div>
</template>
<script>
import { loginOutRequest } from '@/http/api'
import showAndCloseMenu from '@/utils/showAndCloseMenu'
import homepageDefaultLogo from '@/assets/images/cebsb_homelogo.png'
import homepageFixedLogo from '@/assets/images/homepage_di_logo.png'
import LoginChoiceDialog from './LoginChoiceDialog'
export default {
  components: {
    showAndCloseMenu,
    LoginChoiceDialog
  },
  props: {
    isWidth: {
      type: Boolean
    },
    showUserView: {
      type: Boolean
    },
    fixed: {
      type: Boolean
    },
    title: {
      type: String
    },
    pageScroll: {
      type: Boolean
    }
  },
  data () {
    return {
      isActive: false,
      activeIndex: -1,
      hoverIndex: -1,
      childSelectTitle: '',
      childMouseoverIndex: -1,
      childActiveIndex: 0,
      tabbarMenuItem: 'tabbar-menu-item',
      childLeftimg: '',
      childLeftDesc: '',
      seleTabChildList: [],
      nowMenuList: [],
      lastMenuList: [],
      lang: 'en-US',
      currentLang: 'EN',
      loginType: '',
      userMenuVisible: false,
      loginDialogVisible: false,
      logoutConfirmVisible: false,
      mobileLoginTipVisible: false,
      mobileLoginTipTitle: '',
      mobileLoginTipMessage: '',
      mobileLoginTipConfirmText: '',
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024
    }
  },
  computed: {
    isMobileScreen () {
      return this.windowWidth <= 768
    },
    logoSrc () {
      return this.fixed ? homepageFixedLogo : homepageDefaultLogo
    },
    tabChildList () {
      return [
      ]
    },
    tabBarList () {
      return [
        { topTitle: this.$t('h.home'), linkUrl: '/HomeView' },
        {
          topTitle: this.$t('h.aboutCebsb'),
          childList: [
            { childTitle: this.$t('h.backgroundTitle'), isActive: false, linkStr: '/aboutBackground', imgUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebsb_daohang_1.png', desc: this.$t('h.aboutCebsbDesc') },
            { childTitle: this.$t('h.visionTitle'), isActive: false, linkStr: '/aboutVision', imgUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebsb_daohang_1.png', desc: this.$t('h.aboutCebsbDesc') },
            { childTitle: this.$t('h.committeeTitle'), isActive: false, linkStr: '/aboutCommttee', imgUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebsb_daohang_1.png', desc: this.$t('h.aboutCebsbDesc') },
            { childTitle: this.$t('h.honourTitle'), isActive: false, linkStr: '/aboutHonour', imgUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/cebsb_daohang_1.png', desc: this.$t('h.aboutCebsbDesc') }
          ]
        },
        { topTitle: this.$t('h.competitions'), linkUrl: '/invGameType' },
        { topTitle: this.$t('h.eLearn'), linkUrl: '/eLearn' },
        { topTitle: this.$t('h.globalFinals'), linkUrl: '/globalFinals' },
        { topTitle: this.$t('h.FAQ'), linkUrl: '/FAQ' },
        { topTitle: this.$t('h.joinUs'), linkUrl: '/joinUs' }
      ]
    }
  },
  mounted () {
    // 优先从 Vuex store 恢复激活菜单 index
    const savedIndex = this.$store.state.activeMenuIndex
    if (savedIndex !== undefined && savedIndex !== null && savedIndex !== '' && savedIndex !== -1) {
      this.activeIndex = savedIndex
    }

    // fallback：根据当前路由路径匹配
    const path = this.$route.path
    const arr = this.tabBarList.map(item => item.linkUrl)
    const index = arr.findIndex(item => item === path)
    const haveChildIndex = 1
    const arr2 = this.tabBarList[haveChildIndex].childList.map(item => item.linkStr)
    const index2 = arr2.findIndex(item => item === path)
    if (index !== -1) {
      this.activeIndex = index
    } else if (index2 !== -1) {
      this.activeIndex = haveChildIndex
    } else {
      this.activeIndex = -1
    }

    this.loginType = localStorage.getItem('LOGIN_TYPE')
    // 初始化语言状态
    const savedLang = localStorage.getItem('locale')
    if (savedLang) {
      this.currentLang = savedLang
      this.$i18n.locale = savedLang
    }
    // 初始化登录状态
    this.checkLoginStatus()
    // 监听 storage 事件，响应跨标签页的登录/退出登录
    window.addEventListener('storage', this.handleStorageChange)
    // 监听窗口变化，用于登录弹窗响应式
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy () {
    // 移除事件监听
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('resize', this.handleWindowResize)
  },
  watch: {
    activeIndex (val) {
      this.$store.commit('SET_ACTIVEMENUINDEX', val)
    },
    // 路由变化时强制回到页面顶部
    $route () {
      this.scrollToTop()
      // 路由变化时重新检查登录状态
      this.checkLoginStatus()
    },
    '$store.state.activeMenuIndex' (newVal) {
      // 直接监听深层状态
      this.activeIndex = newVal
    }
  },
  methods: {
    // 检查登录状态
    checkLoginStatus () {
      const token = localStorage.getItem('Authorization')
      const loginType = localStorage.getItem('LOGIN_TYPE')
      // token 和 loginType 都存在时才显示用户菜单
      this.$log.debug('headerMenu', 'token', token)
      this.$log.debug('headerMenu', 'loginType', loginType)
      this.userMenuVisible = !!(token && loginType)
      if (this.userMenuVisible) {
        this.loginType = loginType
      } else {
        this.loginType = ''
      }
    },
    // 处理 storage 变化事件（跨标签页同步）
    handleStorageChange (e) {
      if (e.key === 'Authorization' || e.key === 'LOGIN_TYPE') {
        this.checkLoginStatus()
      }
    },
    handleWindowResize () {
      this.windowWidth = window.innerWidth
    },
    goToQuery () {
      this.$router.push('/query')
      this.scrollToTop()
    },
    mouseover (item, index) {
      this.seleTabChildList = item.childList
      this.isActive = false
      if (!this.seleTabChildList.length) return
      if (index !== this.activeIndex) {
        this.childActiveIndex = 0
      }
      this.childLeftimg = this.seleTabChildList[this.childActiveIndex].imgUrl
      this.childLeftDesc = this.seleTabChildList[this.childActiveIndex].desc
      this.isActive = true
      this.hoverIndex = index
    },
    mouseleave (index) {
      if (index === 1) return
      this.childMouseoverIndex = -1
    },
    handleToPage (item, index) {
      console.log(item)
      // 设置选中状态
      this.activeIndex = index
      // 直接跳转的菜单
      if (item.linkUrl) {
        this.isActive = false
        this.$router.push(item.linkUrl)
        this.scrollToTop()
      } else {
        // 其余菜单点击时展开子菜单
        this.seleTabChildList = this.tabChildList[index]
        if (index !== this.activeIndex) {
          this.childActiveIndex = 0
        }
        // 初始化左侧预览内容
        this.childLeftimg = this.tabChildList[index][this.childActiveIndex].imgUrl
        this.childLeftDesc = this.tabChildList[index][this.childActiveIndex].desc
        this.isActive = true
      }
    },
    goTohome () {
      this.activeIndex = 0
      this.$router.push('/')
      this.scrollToTop()
    },
    mouseleaveChildmenu () {
      this.isActive = false
    },
    // 子级菜单点击
    childitemClicked (childIndex, childItem) {
      this.childMouseoverIndex = childIndex
      this.$set(this.seleTabChildList[childIndex], 'isActive', true)
      this.$set(this.seleTabChildList[childIndex], 'isActive', true)
      this.childSelectTitle = this.seleTabChildList[childIndex].childTitle
      this.isActive = false
      this.activeIndex = this.hoverIndex
      const turnUrl = this.seleTabChildList[childIndex].linkStr
      this.$log.debug('headerMenu', turnUrl, childItem)
      if (childItem.checkUserInfo) {
        this.checkUserInfoFn().then(res => {
          if (res.code === 200) {
            this.$router.push(turnUrl)
            this.scrollToTop()
          } else if (res.code === 2014) {
            // 未完善个人信息
          }
        })
      } else {
        this.$router.push(turnUrl)
        this.scrollToTop()
      }
    },
    async checkUserInfoFn () {
      return await this.$http.get('/user/checkBasicsUserInfo')
    },
    childMouseover (childIndex) {
      this.childMouseoverIndex = childIndex
      this.childLeftimg = this.seleTabChildList[childIndex].imgUrl
      this.childLeftDesc = this.seleTabChildList[childIndex].desc
    },
    // 点击右侧头像信息事件
    visibleChange () {
      // 隐藏顶部展开的菜单
      this.isActive = false
    },
    // 用户菜单点击事件
    userMenuCommand (command) {
      this.$log.debug('headerMenu', 'click on item ' + command)
      this.$log.debug('headerMenu', 'loginType', this.loginType)
      switch (command) {
        case 'userInfo':
          if (this.loginType === '1') {
            this.$router.push('/stu/dashboard')
            this.scrollToTop()
          } else if (this.loginType === '2' || this.loginType === '3' || this.loginType === '4') {
            this.$router.push('/partner/dashboard')
            this.scrollToTop()
          }
          break
        case 'orderList':
          break
        case 'loginOut':
          this.userLoginOut()
          break
      }
    },
    // 用户点击登录
    userLoginClicked () {
      this.$router.push({
        path: '/chnEngLogin',
        params: {
          pushUrl: ''
        }
      })
      this.scrollToTop()
    },
    // 学生登录
    studentLoginClicked () {
      this.$router.push({
        path: '/chnEngLogin',
        params: {
          pushUrl: ''
        }
      })
      this.scrollToTop()
    },
    // 检测是否为移动端设备
    isMobile () {
      const regexMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|MicroMessenger/i
      return regexMobile.test(navigator.userAgent)
    },
    // 处理登录按钮点击
    handleLoginClick () {
      // 如果是移动端，显示提示弹窗
      // if (this.isMobile()) {
      //   this.showMobileLoginTip()
      // } else {
      // PC端正常显示登录选择弹窗
      this.loginDialogVisible = true
      // }
    },
    // 显示移动端登录提示
    showMobileLoginTip () {
      const isEnglish = this.$i18n.locale === 'EN'
      this.mobileLoginTipTitle = isEnglish ? 'Login Notice' : '登录提示'
      this.mobileLoginTipMessage = isEnglish
        ? 'For the best user experience, please log in on a PC to access all features.'
        : '为确保您的使用体验，请您在PC端登录，使用后续功能。'
      this.mobileLoginTipConfirmText = isEnglish ? 'OK' : '确认'
      this.mobileLoginTipVisible = true
    },
    // 关闭移动端登录提示
    closeMobileLoginTip () {
      this.mobileLoginTipVisible = false
    },
    // 合作机构登录
    partnerLoginClicked () {
      this.$router.push({
        path: '/partnerLogin'
      })
      this.scrollToTop()
    },
    // 教室端登录
    teacherLoginClicked () {
      this.$router.push({
        path: '/teacherLogin'
      })
      this.scrollToTop()
    },
    // 退出登录
    userLoginOut () {
      // 显示确认弹窗
      this.logoutConfirmVisible = true
    },
    // 确认退出登录
    handleLogoutConfirm () {
      this.logoutConfirmVisible = false
      this.$curUtils.openLoading(this)
      loginOutRequest().then((_res) => {
        this.$curUtils.closeLoading(this)
        window.sessionStorage.clear()
        localStorage.clear()
        // 清除登录状态后重新检查
        this.checkLoginStatus()
        this.$router.push({
          path: '/HomeView',
          params: {
            pushUrl: ''
          }
        })
        this.activeIndex = 0
        this.scrollToTop()
      }).catch((err) => {
        this.$curUtils.closeLoading(this)
        this.$log.debug('headerMenu', '返回的err', err)
      })
    },
    // 取消退出登录
    handleLogoutCancel () {
      this.logoutConfirmVisible = false
    },
    changeLang (lang) {
      this.lang = lang
      this.$i18n.locale = lang
    },
    // 语言切换方法
    switchLanguage (lang) {
      this.currentLang = lang
      this.$i18n.locale = lang
      localStorage.setItem('locale', lang)
    },
    scrollToTop () {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      } catch (e) {
        window.scrollTo(0, 0)
      }
    }
  }
}

</script>
<style scoped lang="less">
.top-gradient-bar{
  width: 100vw;
  height: 30px;
  background-image: linear-gradient(to right, #030303, #420e13);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.top-gradient-inner{
  // width: 1400px;
  height: 30px;
  // margin: 0 auto;
  margin-right: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.certificate-link{
  color: #fff;
  font-size: 14px;
  line-height: 1;
  margin-right: 20px;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
}
.topBox {
  width: 100vw;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  height: 90px;
  position: relative;
}
.top-tabview {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #811d21;
  // position: fixed; /*固定在顶部*/
  // top: 0; /*离顶部的距离为0*/
  margin: 0 auto;
}
.top-leftlogo {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 70px;
  margin-left: 10px;
  .top-leftlogo-image {
    width: 281px;
    height: 56px;
    border-radius: 12px;
    object-fit: contain;
    cursor: pointer;
  }
  .top-leftlogo-text-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.2;
  }
  .top-leftlogo-text {
    font-size: 22px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #000;
    &.is-fixed {
      color: #fff;
    }
  }
  .top-leftlogo-text-sub {
    font-size: 12px;
    font-weight: 400;
    color: #222222;
    &.is-fixed {
      color: #f5f5f5;
    }
  }
}
.right-menu-backview {
  width: 900px;
  margin-right: 20px;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .right_tabbar_menuview {
    width: 800px;
    height: 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    button{
      cursor: pointer;
    }
  }
  .top-right-headView {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 5px;
    display: flex;
  }
  .top-right-login-buttons {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 15px;

    // 英文模式下两行显示
    &.is-english {
      .login-btn {
        flex-direction: column;
        padding: 8px 10px;

        .login-text {
          line-height: 1.1;
          font-size: 11px;
        }
      }
    }

    .login-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-weight: 500;
      padding: 4px 16px;
      border: none;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      outline: none;
      white-space: nowrap;

      .login-text {
        line-height: 1;
        white-space: nowrap;
        text-align: center;
        display: inline-block;
      }

      &:active {
        transform: scale(0.98);
      }
    }
    .login-btn-signin,
    .login-btn-student {
      color: #fff;
      background: linear-gradient(135deg, #b81c25 0%, #d32f2f 100%);
      box-shadow: 0 2px 8px rgba(184, 28, 37, 0.3);
      &:hover {
        background: linear-gradient(135deg, #d32f2f 0%, #b81c25 100%);
        box-shadow: 0 4px 12px rgba(184, 28, 37, 0.4);
        transform: translateY(-1px);
      }
    }
    .login-btn-partner {
      color: #b81c25;
      background: #fff;
      border: 2px solid #b81c25;
      box-shadow: 0 2px 6px rgba(184, 28, 37, 0.15);
      &:hover {
        color: #fff;
        background: #b81c25;
        box-shadow: 0 4px 12px rgba(184, 28, 37, 0.3);
        transform: translateY(-1px);
      }
    }
  }
  .top-right-user{
    margin-right: 10px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

// 登录选择弹窗样式已迁移至 LoginChoiceDialog.vue 组件

.normal_type {
  padding: 0px 20px;
  font-size: 12px;
  font-family: hzgb;
  color: #ffffff;
  text-align: center;
  height: 30px;
  line-height: 34px;
  background-color: transparent;
  border: 0;
  position: relative;
  transition: border-bottom 0.3s ease;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  &:hover {
    border-bottom: 2px solid #f8bd1d;
  }
}
.chose_type {
  padding: 0px 20px;
  font-size: 13px;
  font-family: hzgb;
  color: #f7b52e;
  text-align: center;
  height: 30px;
  line-height: 34px;
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid #f7b52e;
  position: relative;
}

.menu-button-class {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  background-image: url(../assets/images/right-menu-img.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.tabbar_child_childmenu_backview {
  position: absolute;
  top: 50px;
  z-index: 1002;
  // padding-top: 20px;
}
.tabbar_child_childmenu {
  // width: 640px;
  margin-top: 20px;
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  // height: 140px;
  border-radius: 40px;
}
.child-left-imgview {
  width: 148px;
  height: 110px;
}
.child-left-descview {
  color: white;
  width: 330px;
  // height: 120px;
  margin: 15px 10px;
  text-align: left;
  font-size: 12px;
}
.child-center-lineview {
  width: 1px;
  background-color: white;
  height: 120px;
}
.child-right-itemview {
  // width: 150px;
  padding: 15px 10px;
  // height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.child-item-selectmenu {
  width: 100%;
  text-align: left;
  color: rgb(200, 24, 24);
  font-size: 12px;
  line-height: 20px;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}
.child-item-unselectmenu {
  width: 100%;
  text-align: left;
  color: rgb(255, 255, 255);
  font-size: 12px;
  line-height: 20px;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}
.topBoxFixed{
  height: auto;
  .top-con{
    height: 90px;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1010;
    background-image: linear-gradient(rgba(0,0,0,.7), transparent);
  }
  .top-con-bg{
    background-color: #000;
  }
  .normal_type{
    color: #fff;
  }
  .top-tabview{
    background-color: transparent;
  }
  .menu-button-class{
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 6px;
  }
  // fixed状态下登录按钮样式优化
  .top-right-login-buttons {
    .login-btn-student {
      background: linear-gradient(135deg, rgba(184, 28, 37, 0.9) 0%, rgba(211, 47, 47, 0.9) 100%);
      backdrop-filter: blur(10px);

      &:hover {
        background: linear-gradient(135deg, rgba(211, 47, 47, 0.95) 0%, rgba(184, 28, 37, 0.95) 100%);
      }
    }

    .login-btn-partner {
      color: #fff;
      background: rgba(255, 255, 255, 0.2);
      border: 2px solid rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10px);

      &:hover {
        color: #fff;
        background: rgba(184, 28, 37, 0.8);
        border-color: rgba(184, 28, 37, 0.9);
      }
    }
  }
}
.top-bg-con{
  width: 100%;
  // height: 210px;
  height: 90px;
  background-image: url(../assets/images/top-bg.png);
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 100% auto;
  color: #fff;
  text-align: center;
  font-size: 30px;
  line-height: 240px;
  font-family: regular;
}
.lang-change-con{
  position: absolute;
  right: 0;
  left: 0;
  bottom: -40px;
  z-index: 1002;
}
.lang-change{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 1000px;
  margin: 0 auto;
  padding-right: 42px;
  .lang{
    width: 60px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    background-color: #000;
    border-radius: 20px;
    cursor: pointer;
    margin-left: 10px;
    &.currentLang{
      background-color: #b81c25;
    }
  }
}

// 语言切换样式
.language-switcher {
  // display: none;
  // position: fixed;
  // top: 15px;
  // right: 15px;
  // display: flex;
  gap: 8px;
  // z-index: 10000;
  // background-color: rgba(255, 255, 255, 0.95);
  padding: 5px 8px;
  // border-radius: 8px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;

  .lang-btn {
    padding: 4px 10px;
    background-color: transparent;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    color: #666;
    transition: all 0.3s;
    min-width: 32px;
    text-align: center;
    line-height: 1.2;

    &:hover {
      background-color: #f5f5f5;
      border-color: #b81c25;
    }

    &.active {
      background-color: #b81c25;
      color: white;
      border-color: #b81c25;
      font-weight: 500;
    }
  }
}

// 响应式设计 - 移动端优化
@media (max-width: 768px) {
  .topBox {
    height: 90px; // 70px + 15px
  }

  .top-tabview {
    height: 90px; // 70px + 15px
  }

  .top-leftlogo {
    height: 90px; // 70px + 15px
  }

  .right-menu-backview {
    height: 90px; // 70px + 15px
  }

  .right_tabbar_menuview {
    height: 90px; // 70px + 15px
  }

  .normal_type {
    font-size: 17px !important; // 12px + 5px
    height: 45px !important; // 30px + 15px
  }

  .chose_type {
    font-size: 18px !important; // 13px + 5px
    height: 45px !important; // 30px + 15px
  }

  .top-right-login-buttons {
    gap: 8px;
    margin-right: 10px;

    .login-btn {
      font-size: 11px;
      padding: 6px 12px;
      gap: 4px;

      i {
        font-size: 12px;
      }

      span {
        display: none; // 移动端只显示图标
      }

      &:hover {
        transform: none; // 移动端取消hover效果
      }
    }
  }
}

// @media (max-width: 480px) {
//   .right-menu-backview {
//     width: 80px;
//     height: 80px;
//   }

//   .right_tabbar_menuview {
//     width: 80px;
//     height: 80px;
//   }
// }

// 移动端登录提示弹窗样式 - 全局样式（不使用scoped）

::v-deep .mobile-login-tip-dialog {
  .el-message-box__wrapper {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 20px !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    margin: 0 !important;
  }

  .el-message-box {
    border-radius: 20px !important;
    width: 90% !important;
    max-width: 420px !important;
    margin: 0 !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15) !important;
    overflow: hidden;
    border: none !important;
    background: #fff !important;
  }

  .el-message-box__header {
    padding: 28px 24px 20px 24px !important;
    text-align: center !important;
    border-bottom: none !important;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  }

  .el-message-box__headerbtn {
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.05);
    transition: all 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    .el-message-box__close {
      font-size: 18px;
      color: #666;
    }
  }

  .el-message-box__title {
    font-size: 20px !important;
    font-weight: 700 !important;
    color: #333 !important;
    letter-spacing: 0.5px !important;
    padding: 0 !important;
  }

  .el-message-box__content {
    padding: 24px !important;
    text-align: center !important;
  }

  .el-message-box__message {
    font-size: 16px !important;
    line-height: 1.7 !important;
    color: #555 !important;
    text-align: center !important;
    padding: 0 !important;
    margin: 0 !important;

    p {
      margin: 0 !important;
      padding: 0 !important;
      font-size: 16px !important;
      line-height: 1.7 !important;
      color: #555 !important;
    }
  }

  .el-message-box__btns {
    padding: 0 24px 24px 24px !important;
    text-align: center !important;
  }

  .el-message-box__btns .el-button {
    width: 100% !important;
    padding: 14px 0 !important;
    font-size: 17px !important;
    border-radius: 12px !important;
    background: linear-gradient(135deg, #b81c25 0%, #d32f2f 100%) !important;
    border: none !important;
    font-weight: 600 !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 4px 12px rgba(184, 28, 37, 0.3) !important;
    transition: all 0.3s !important;
    color: #fff !important;

    &:hover {
      box-shadow: 0 6px 16px rgba(184, 28, 37, 0.4) !important;
      transform: translateY(-1px) !important;
      background: linear-gradient(135deg, #c92d36 0%, #e03a3a 100%) !important;
    }

    &:active {
      transform: translateY(0) scale(0.98) !important;
      box-shadow: 0 2px 8px rgba(184, 28, 37, 0.3) !important;
    }
  }
}

@media (max-width: 480px) {
  ::v-deep .mobile-login-tip-dialog {
    .el-message-box__wrapper {
      padding: 15px !important;
    }

    .el-message-box {
      width: 92% !important;
      max-width: 380px !important;
      border-radius: 18px !important;
    }

    .el-message-box__header {
      padding: 24px 20px 18px 20px !important;
    }

    .el-message-box__headerbtn {
      top: 14px !important;
      right: 14px !important;
      width: 30px !important;
      height: 30px !important;
      line-height: 30px !important;
    }

    .el-message-box__title {
      font-size: 19px !important;
    }

    .el-message-box__content {
      padding: 20px !important;
    }

    .el-message-box__message {
      font-size: 15px !important;
      line-height: 1.6 !important;

      p {
        font-size: 15px !important;
        line-height: 1.6 !important;
      }
    }

    .el-message-box__btns {
      padding: 0 20px 20px 20px !important;
    }

    .el-message-box__btns .el-button {
      font-size: 16px !important;
      padding: 13px 0 !important;
      border-radius: 10px !important;
    }
  }
}

// 移动端登录提示自定义弹窗样式
.mobile-login-tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 800px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.mobile-login-tip-dialog {
  background: #fff;
  border-radius: 24px;
  width: 60%;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideUp 0.3s ease;
  position: relative;
}

.tip-dialog-header {
  padding: 40px 32px 32px 32px;
  text-align: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: none;
}

.tip-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #b81c25 0%, #d32f2f 100%);
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(184, 28, 37, 0.3);

  i {
    font-size: 40px;
    color: #fff;
  }
}

.tip-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  letter-spacing: 0.5px;
  margin: 0;
}

.tip-dialog-content {
  padding: 32px;
  text-align: center;
}

.tip-message {
  font-size: 30px;
  line-height: 1.7;
  color: #555;
  margin: 0;
}

.tip-dialog-footer {
  padding: 0 32px 32px 32px;
  text-align: center;
}

.tip-confirm-btn {
  width: 100%;
  padding: 18px 0;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 12px;
  background: linear-gradient(135deg, #b81c25 0%, #d32f2f 100%);
  border: none;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(184, 28, 37, 0.3);
  transition: all 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    box-shadow: 0 6px 16px rgba(184, 28, 37, 0.4);
    transform: translateY(-1px);
    background: linear-gradient(135deg, #c92d36 0%, #e03a3a 100%);
  }

  &:active {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 2px 8px rgba(184, 28, 37, 0.3);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .mobile-login-tip-overlay {
    width: 100%;
    padding: 15px;
  }

  .mobile-login-tip-dialog {
    width: 60%;
    // max-width: 480px;
    border-radius: 22px;
  }

  .tip-dialog-header {
    padding: 36px 28px 28px 28px;
  }

  .tip-icon-wrapper {
    width: 72px;
    height: 72px;
    margin-bottom: 20px;

    i {
      font-size: 36px;
    }
  }

  .tip-title {
    font-size: 30px;
  }

  .tip-dialog-content {
    padding: 28px;
  }

  .tip-message {
    font-size:30px;
    line-height: 1.6;
  }

  .tip-dialog-footer {
    padding: 0 28px 28px 28px;
  }

  .tip-confirm-btn {
    font-size: 20px;
    padding: 17px 0;
    border-radius: 10px;
  }
}
</style>
